import React from 'react'
let PropTypes = React.PropTypes
import Modal from 'react-bootstrap/lib/Modal.js'
import classNames from 'classnames/bind'
import * as cssModal from '../../asignacion-fondos/Modales.css'
let cx = classNames.bind(cssModal)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = {visible: false}
        let self = this
        this.show = ()=>
            self.setState({visible: true})
        this.hide = ()=>{
            self.setState({visible: false})
        }
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class RechazarGasto extends React.Component{
    constructor(props){
        super(props)
        this.state = {
        }
        this.handleSubmit = (evt)=>{
            evt.preventDefault()
            evt.stopPropagation()
            this.context.rechazarGasto(this.props.idGasto)
                .then(resp=>{
                    this.props.hideModal()
                })
                .catch(err=>{
                    console.log(err)
                })
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalPublicar')} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>¿Esta seguro de rechazar este gasto?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <form className="col-md-12 col-sm-12 form-horizontal" action="" onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="exampleFormControlTextarea1">Favor indicar el motivo de su rechazo</label>
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="2"></textarea>
                            </div>
                            <div className="col-md-6  pull-left">
                                <button className="btn btn-md btn-success" type="submit"><span className="glyphicon glyphicon-ok"/> Aceptar</button>
                            </div>
                            <div className="col-md-6  pull-right">
                                <button className="btn btn-md btn-cancel" onClick={this.props.hideModal}><span className="glyphicon glyphicon-remove"/> Cancelar</button>
                            </div>
                        </form>    
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}
RechazarGasto.contextTypes = {
    rechazarGasto: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/revision-rendiciones/detalle-rendicion/Modales.jsx